export function isValidType<P>(value: unknown): value is P {
  if (typeof value === 'string') return true;
  else return true;
}
